export default __webpack_public_path__ + "static/media/groupIns2.453ba38a.jpg";